document.addEventListener("DOMContentLoaded", () => {
  const wrapper = document.querySelector(".vendors-carousel .carousel-wrapper");
  const btnPrev = document.querySelector(".carousel-btn.prev");
  const btnNext = document.querySelector(".carousel-btn.next");
  if (!wrapper || !btnPrev || !btnNext) return;

  const gap = 24;
  const visibleDesktop = 4;
  const visibleTablet = 2;
  const visibleMobile = 1;

  const getVisible = () => {
    if (window.innerWidth <= 749) return visibleMobile;
    if (window.innerWidth <= 1024) return visibleTablet;
    if (window.innerWidth <= 1280) return 3;
    if (window.innerWidth <= 1920) return 4;
    if (window.innerWidth > 1920) return 5;

    return visibleDesktop;
  };

  const originals = Array.from(wrapper.children);
  let v = getVisible();

  originals.forEach((_, i) => {
    if (i >= originals.length - v) {
      const c = originals[i].cloneNode(true);
      c.classList.add("clone");
      c.querySelectorAll("a, button, img, h3").forEach((el) => {
        el.setAttribute("tabindex", "-1");
        el.setAttribute("aria-hidden", "true");
      });
      c.setAttribute("aria-hidden", "true");
      wrapper.insertBefore(c, wrapper.firstChild);
    }
    if (i < v) {
      const c = originals[i].cloneNode(true);
      c.classList.add("clone");
      c.querySelectorAll("a, button, img, h3").forEach((el) => {
        el.setAttribute("tabindex", "-1");
        el.setAttribute("aria-hidden", "true");
      });
      c.setAttribute("aria-hidden", "true");
      wrapper.appendChild(c);
    }
  });

  const slides = Array.from(wrapper.children);
  const originalCount = originals.length;
  let logicalIndex = 0;

  const slideWidth = () => slides[0].offsetWidth + gap;

  const update = () => {
    const transformIndex = logicalIndex + v;
    wrapper.style.transform = `translateX(${-slideWidth() * transformIndex}px)`;
    slides.forEach((s, i) => {
      s.classList.toggle(
        "visible",
        i >= transformIndex && i < transformIndex + v
      );
    });
  };

  update();

  const moveWithLoop = (newIndex) => {
    wrapper.classList.add("no-transition");
    logicalIndex = newIndex;
    update();

    requestAnimationFrame(() => {
      wrapper.classList.remove("no-transition");
      update(); 
    });
  };

  btnNext.addEventListener("click", () => {
    logicalIndex++;
    if (logicalIndex >= originalCount) {
      moveWithLoop(0);
    } else {
      update();
    }
  });

  btnPrev.addEventListener("click", () => {
    logicalIndex--;
    if (logicalIndex < 0) {
      moveWithLoop(originalCount - 1);
    } else {
      update();
    }
  });

  window.addEventListener("resize", () => {
    v = getVisible();
    logicalIndex = 0;
    update();
  });

  let startX = 0,
    dragging = false,
    curr = 0,
    prevX = 0,
    anim;
  const animate = () => {
    wrapper.style.transform = `translateX(${curr}px)`;
    if (dragging) anim = requestAnimationFrame(animate);
  };


wrapper.addEventListener("touchstart", (e) => {
  if (window.innerWidth > 749) return;
  dragging = true;
  wrapper.classList.add("no-transition"); 
  startX = e.touches[0].clientX;
  prevX = -slideWidth() * (logicalIndex + v);
  curr = prevX;
});

wrapper.addEventListener("touchmove", (e) => {
  if (!dragging) return;
  const deltaX = e.touches[0].clientX - startX;
  curr = prevX + deltaX;

  const min = -slideWidth() * (originalCount + v - 1); 
  const max = -slideWidth() * v;

  if (curr > max) {
    curr = max + (curr - max) / 4;
  } else if (curr < min) {
    curr = min + (curr - min) / 4;
  }

  wrapper.style.transform = `translateX(${curr}px)`;
});

wrapper.addEventListener("touchend", () => {
  if (!dragging) return;
  dragging = false;
  wrapper.classList.remove("no-transition");

  const moved = curr - prevX;
  if (moved < -50) {
    logicalIndex++;
    if (logicalIndex >= originalCount) moveWithLoop(0);
    else update();
  } else if (moved > 50) {
    logicalIndex--;
    if (logicalIndex < 0) moveWithLoop(originalCount - 1);
    else update();
  } else {
    update(); 
  }
});
});
